import {IActionPassData, IActionTriggerData, IFormItemsControls, IFormStructure} from './form-structure';
import {IAPIURLs, IHttpSetting} from './dataset-params';
import {EventEmitter} from '@angular/core';
import {SurveyQuestionStructure} from '../components/Items/FormItems/survey/survey.component';

export interface FormItemComponentInterface {
    prop: IFormItemsControls;
    setting?: IHttpSetting;
    datasetId?: any;
    formId: number;
    isFilter?: boolean;

    keyOnEnter?: EventEmitter<any>;
}

export interface ISurveySelected {
    value: any;
    title: any;
    point: number;
    ext_value?: any;
    requireValue?: boolean;
}

export interface ISurveySelectedEvent {
    answers:ISurveySelected[];
    question: SurveyQuestionStructure;
}


export interface SurveyFormItemComponentInterface {
    prop: SurveyQuestionStructure;
    setting?: IHttpSetting;
    datasetId?: any;
    formId: number;
    isFilter?: boolean;
    index:number;

    answers?:ISurveySelected[];
    isView?: boolean;

    keyOnEnter?: EventEmitter<any>;

    selectedValue?: EventEmitter<ISurveySelectedEvent>;
}




export enum ActionFlag {
    NEW = 'new',
    EDIT = 'edit'
}


export interface IWizardViewOutput {
    currentStep: number;
    totalStep: number;
}


export interface IFormDialogData {
    formJson?: IFormStructure;
    setting: IHttpSetting;
    API_URLS?: IAPIURLs;
    actionFlag: ActionFlag;
    workFlowObjectId?: any;
    formId: number;
    recordId?: number | 0;
    actionPassedData?: IActionPassData;
    triggerData?: IActionTriggerData[];
    liveValue?: boolean | false;
    isTest?: boolean | false;
    outData?: any;
    window_type?: any;
}
